// SettingsMembersSeatLimitPanel.jsx

import React from 'react';

// CSS
import './SettingsMembersSeatLimitPanel.css';

// Components
import Button from 'components/button/Button';

/**
 * SettingsMembersSeatLimitPanel
 *
 * Renders the seat-limit upgrade CTA or passive member notice in the members pane.
 *
 * @param {boolean} canUpgradePlan - Whether the current user can open billing settings.
 * @param {boolean} isAtSeatLimit - Whether the space is at its seat limit.
 * @param {function} onUpgradePlanClick - Called when the upgrade action is selected.
 * @param {string} seatLimitDescription - Seat-limit summary copy.
 * @param {object} theme - Active theme tokens.
 *
 * @returns {ReactNode} The rendered seat-limit panel.
 */
const SettingsMembersSeatLimitPanel = React.memo(({
    canUpgradePlan,
    isAtSeatLimit,
    onUpgradePlanClick,
    seatLimitDescription,
    theme,
}) => {
    if (!isAtSeatLimit) return null;

    if (canUpgradePlan) {

        return (
            <div
              className="settings-modal-members-seat-limit-panel"
            >

                {/* MEMBERS SEAT LIMIT COPY */}
                <div className="settings-modal-members-seat-limit-copy">

                    {/* MEMBERS SEAT LIMIT TITLE */}
                    <div
                      className="settings-modal-members-seat-limit-title"
                    >
                        Member limit reached
                    </div>

                    {/* MEMBERS SEAT LIMIT DESCRIPTION */}
                    <div
                      className="settings-modal-members-seat-limit-description"
                    >
                        {seatLimitDescription || 'This space has reached its member limit.'}
                        {' '}
                        Upgrade your plan to invite teammates.
                    </div>
                </div>

                <Button
                  iconKey="paid"
                  iconSize={16}
                  label="Upgrade Plan"
                  height="36px"
                  width="auto"
                  borderRadius="6px"
                  fontSize="12px"
                  onClick={onUpgradePlanClick}
                />
            </div>
        );
    }
    // ----- RENDER ----- //

    return (
        <div
          className="settings-modal-note"
          style={{
            color: theme.foregroundMuted,
          }}
        >
            {seatLimitDescription || 'This space has reached its member limit.'}
            {' '}
            Contact a base owner or admin to upgrade the plan and invite more members.
        </div>
    );
});

// Dev Tools
SettingsMembersSeatLimitPanel.displayName = 'SettingsMembersSeatLimitPanel';

export default SettingsMembersSeatLimitPanel;
